/**
 * Remove spaces in phone number and replace leading 0 with +61
 */
export function cleanPhoneNumber(value: string) {
  let phoneNumber = value.replace(/\s+/g, '');
  if (phoneNumber?.indexOf('0') === 0) {
    phoneNumber = '+61' + phoneNumber.substring(1);
  }

  return phoneNumber;
}
